<template>
<div class="home">
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/amend">Amend</router-link>
    </div>
    -->
    <!-- <router-view />-->

    <header class="p-site__header">
        <img class="p-site__header-logo" :src="require(`@/assets/images/study_logo.png`)" />
    </header>
        <section class="ui-nb-wrapper">
            <div class="ui-width-limit">
                <div class="ui-nb-wr">

                <div class="ui-nb-icon-wrap">
                    <span class="fa-stack fa-lg fa-2x">
                        <i class="ui-nb-circle fa fa-circle fa-stack-2x"></i>
                        <i class="ui-nb-icon fa fa-bullhorn fa-stack-1x fa-inverse"></i>
                    </span>
                </div>
                <h2 class="ui-nb-heading">The IPF clinical trial is no longer recruiting patients.  The ILD clinical trial is still open.</h2>
                </div>
            </div>
        </section>
    <main class="p-site__main">
        <centered-layout class="p-site__btn-group">
            <span class="en-only">I am a</span>
            <router-link to="/prw" class="btn btn--primary [ my-4 ]">{{ $t("intro_patient") }}</router-link>
            <router-link to="/hpw" class="btn btn--primary">{{ $t("intro_healthcare") }}</router-link>
        </centered-layout>

    </main>
    <footer class="p-site__footer"></footer>
    <cookie-modal :locale='$i18n.locale' v-on:consentAccepted="acceptConsent">
            <template #body-content> {{ $t("c_text") }} <br /> {{ $t("c_text_two") }}</template>
            <template #privacy-policy-link-text>{{ $t("c_privacy") }}.</template>
            <template #accept-btn-text>{{$t('c_accept')}}</template>
            <template #reject-btn-text>{{$t('c_nocookie')}}</template>
    </cookie-modal>
</div>
</template>

<script>
import CookieModal from "@/components/CookieModal.vue";
import CenteredLayoutVue from '../components/layout/CenteredLayout.vue';
import {consent, wistiaCookieTracking, setHtmlElementLangAttribute,addLocaleToHtmlElementClass} from "@/common/utils";

export default {
    name: "Index",
    components: {
        "centered-layout": CenteredLayoutVue,
        "cookie-modal": CookieModal,
    },
    mounted(){
        setHtmlElementLangAttribute(this.$i18n.locale)
        addLocaleToHtmlElementClass("lang-"+ this.$i18n.locale)
    },
    methods: {
        acceptConsent() {
            consent.setStatus(true);
            //  console.log("Login::consent status is: " + consent.status)
            wistiaCookieTracking(true);
        },
    }
};
</script>

<style lang="scss">
.p-site {
    &__header {
        display: flex;

    }

    &__header-logo {
        display: block;
        margin: 20px auto;
        width: 45%;

        @media screen and (min-width: 700px){
          margin: 40px auto;
          width: 25%;
        } 
    }

    &__main {
        background: $secondary-color; // rgba(189, 69, 16, 0.12);
        background-image: url("../assets/images/study_bg.jpg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 100vh;
        /** for compatibility */
        min-height: calc(100vh - 300px);
        justify-content: center;
    }

    &__btn-group {
        color: white;
        display: flex;
        flex-direction: column;
        height: 120px;
        width: 200px;
        justify-content: space-between !important;
        align-items: stretch;
        text-align: center;

        @media screen and (min-width: 700px){
          font-size: 20px;
          height: 145px;
          width: 270px;
        } 

    }

    &__footer {
        height: 100px;
    }
}

	/*EDIT COLOURS HERE*/
	.ui-nb-wrapper {
		background: #ff5f00;
	}

	.ui-nb-circle {
		color: #00a3e0;
	}

	.ui-nb-icon {
		color: #fff;
	}

	.ui-nb-p,
	.ui-nb-heading {
		color: #fff;
	}

	/*EDIT COLOURS HERE*/
	.ui-width-limit {
		max-width: 1280px;
		margin: 0 auto;
	}

	.ui-nb-wrapper {
		padding: 24px 16px;
	}

	.ui-nb-icon-wrap {
		text-align: center;
	}

	.ui-nb-row {
		display: flex;
		align-items: center;
	}

	.ui-nb-heading {
		font-size: 22px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: 0.75px;
		text-align: center;
		margin-top: 8px;
		margin-bottom: 12px;
	}
.ui-nb-wr{
    display:flex;
    align-items:center;
    justify-content: center;
}
</style>
